<template>
    <v-container fluid :style="{height: selectorHeight + 'px'}">
        <v-row>
            <v-col cols="5">
                <v-row>
                    <v-col cols="12">
                        <v-text-field
                            label="Find Companies"
                            placeholder="Start typing..."
                            v-model="filterCompanies"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <select class="multiple" multiple v-model="selectedCompanies" :style="{height: selectInputHeight + 'px'}">
                            <option v-for="c in filteredCompanies" :label="c.legal_name" :value="c"></option>
                        </select>
                    </v-col>
                </v-row>
            </v-col>

            <v-col cols="2" class="center-buttons">
              <v-btn class="mb-4 white--text" color="blue" @click="addCompanyToClients" block :disabled="selectedCompanies.length === 0"> &gt;&gt; </v-btn>
              <v-btn class="mb-4 white--text" color="blue" @click="removeClient" block :disabled="selectedClients.length === 0"> &lt;&lt; </v-btn>
              <v-btn class="mb-4 white--text" color="blue" @click="saveClients" block :disabled="!saveAvailable">Save</v-btn>
            </v-col>

            <v-col cols="5">
                <v-row>
                    <v-col cols="12">
                        <v-text-field
                           label="Find Cosellers"
                           placeholder="Start typing..."
                           v-model="filterSelectedCosellers"
                       ></v-text-field>

                    </v-col>
                    <v-col cols="12">
                        <select class="multiple" multiple v-model="selectedClients" :style="{height: selectInputHeight + 'px'}">
                            <option v-for="c in filteredCosellers" :label="c.legal_name" :value="c"></option>
                        </select>
                    </v-col>
                </v-row>
                
                
            </v-col>
        </v-row>
        
    </v-container>
</template>

<script>
import axios from 'axios'

export default {
    name: 'ManageCosellers',
    data () {
        return {
          availableCompanies: [],
            clients: [],
            filterCompanies: '',
            filterSelectedCosellers: '',
            saveAvailable: false,
            selectedCompanies: [''],
            selectedClients: [''],
            selectorHeight: 200,
            selectInputHeight: 200,
        }
    },
    computed: {
        filteredCompanies () {
            const co_sellers = this.clients.map(c => c.legal_name)
            return this.availableCompanies.filter(c => c.legal_name.toLowerCase().includes(this.filterCompanies.toLowerCase()) ) // && !co_sellers.includes(c.legal_name)
        },
        filteredCosellers () {
            return this.clients.filter(c => c.legal_name.toLowerCase().includes(this.filterSelectedCosellers.toLowerCase()))
        },  
        clientIds () {
            return this.clients.map(client => client.id)
        },
        baseURL () {
            const userId = this.$store.state.id
            return `${this.$store.getters.baseURL}/api/user/${userId}/co_sellers`
        }
    },
    mounted () {
        Promise.all([this.getClients(), this.getAllCompanies()]).then((values) => this.filterDuplicateCompanies(values))
        // this.getClients()
        // this.getAllCompanies()
        const selectorHeightOffset = 150
        const selectInputHeightOffset = 250
        this.selectInputHeight = window.innerHeight - selectInputHeightOffset
        this.selectorHeight = window.innerHeight - selectorHeightOffset
        window.addEventListener('resize', () => {
            this.selectInputHeight = window.innerHeight - selectInputHeightOffset
            this.selectorHeight = window.innerHeight - selectorHeightOffset
        })
    },
    unmounted () {
        window.removeEventListener('resize')
    },
    methods: {
        filterDuplicateCompanies () {
            // After loading both, get rid of companies from available companies that are in the co-sellers
            const cosellerNames = this.clients.map(c => c.legal_name)
            this.availableCompanies = this.availableCompanies.filter(company => !cosellerNames.includes(company.legal_name))
        },
        addCompanyToClients () {
            this.selectedCompanies.forEach((element) => {
              this.clients.push(element)
              this.availableCompanies.splice(this.availableCompanies.findIndex(e => e.legal_name === element.legal_name), 1)
            });
            this.saveAvailable = true
        },
        removeClient () {
          this.selectedClients.forEach((element) => {
            this.availableCompanies.push(element)
            this.clients.splice(this.clients.findIndex(e => e.legal_name === element.legal_name), 1)
          })
          this.selectedClients = []
            this.saveAvailable = true
        },
        saveClients () {
            axios({
                method: 'post',
                url: this.$store.getters.baseURL + '/api/user/'+ this.$store.state.id +'/co_sellers/update/',
                headers: {
                    'Authorization': `Token ${this.$store.state.userToken}`
                },
                data: this.clientIds
            })
            .then( () => {
                this.$toast.success('Saved clients succesfully!', {
                    timeout: 2000
                })
                this.saveAvailable = false
                this.$store.commit('setMatrixReloadNeeded', true)
            })
            .catch( () => {
                this.$toast.error('Unable to save for some reason.')
            })
        },
        getClients () {

            return axios({
                method: 'get',
                url: this.baseURL,
                headers: {
                    'Authorization': `Token ${this.$store.state.userToken}`
                }
            })
            .then(res => {
                this.clients = [...res.data.co_sellers];
                return this.clients
            })
            .catch(err => {
                console.error(err);
            });
        },
        getAllCompanies () {
          return axios({
              method: 'get',
              url: this.$store.getters.baseURL + '/api/company/all',
              headers: {
                  'Authorization': `Token ${this.$store.state.userToken}`
              }
          })
          .then(res => {
              this.availableCompanies = res.data;
              return this.availableCompanies
          })
          .catch(err => {
              console.error(err);
          });

        },
    }
}

</script>

<style scoped>
select.multiple {
    width: 100%;
    padding: 0.4em;
    border-bottom: 1px solid #aaaa;
    overflow-y: auto;
    margin: -1em 0 1em 0;
}

select.multiple option {
    padding: .4em .2em;
}

.center-buttons {
    padding-top: 8em;
}

</style>
